export default function parseXml(xml) {
  const categories = [];
  const $xml = $(xml);
  const $categories = $xml.find('category');
  $categories.each(function() {
    const $category = $(this);
    const $subjects = $category.find('subjects subject');
    const category = {
      id      : $category.attr('id'),
      name    : $category.attr('name'),
      open    : $category.attr('open') === 'true',
      subjects: [],
    };
    $subjects.each(function() {
      const $subject = $(this);
      const childrenId = $subject.attr('children');
      const subject = {
        id        : $subject.attr('id'),
        name      : $subject.attr('name'),
        max       : parseInt($subject.attr('max'), 10),
        childrenId: childrenId === 'null' ? null : childrenId,
        open      : $subject.attr('open') === 'true',
      };
      category.subjects.push(subject);
    });
    categories.push(category);
  });
  return categories;
}


// WEBPACK FOOTER //
// ./src/js/store/modules/selfcheck/parseXml.js